import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class PiWhitelistFilter {
    includes = [];
    excludes = [];
    list = [];
    whitelist = [];

    public start(list) {
        this.includes = [];
        this.excludes = [];
        this.list = list;

        return this;
    }

    public input(whitelist: []) { 
        this.whitelist = Array.isArray(whitelist) ? whitelist : [];

        return this;
    }

    public filter() {
        this.whitelist.forEach(name => {
            const found = this.list.find(entry => {
                return entry.Name === name;
            });

            if (found) {
                this.includes.push(found);
            }
        });

        return this;
    }

    public exclude() {
        return Array.from(this.excludes);
    }

    public include() {
        return Array.from(this.includes);
    }
}
